import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Constants } from 'projects/reg-hub-client/src/constants';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { EmptyEntityService, ePartyType, Order, OrderManagerService, PartiesFormComponent, Party, PartyRepositoryService, ReusableParty, ReusablePartyRepositoryService, UIConfigurationService, Utilities, ValidationProblem, ValidationService } from 'reg-hub-common';
import { PartiesComponent } from '../parties/parties.component';
import { eCriteriaVariation } from '../../services/stepper/steps/search-stepper';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-secured-party',
    templateUrl: './secured-party.component.html',
    styleUrls: ['./secured-party.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SecuredPartyComponent extends PartiesComponent {
  @Input() criteriaVariations: eCriteriaVariation[] = []
  @ViewChild(PartiesFormComponent) securedPartyForm!: PartiesFormComponent;

  protected businessSecuredParty = ePartyType.businessSecuredParty;
  protected individualSecuredParty = ePartyType.individualSecuredParty;
  protected defaultType = ePartyType.businessSecuredParty;

  protected reusableParties: ReusableParty[] = [];

  protected securedParty!: Party;

  constructor(
    partyRepository: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService,
    private emptyEntityService: EmptyEntityService,
    private reusablePartiesService: ReusablePartyRepositoryService) {
    super(partyRepository, uiConfigurationService, orderManager, validationService);
  }

  public override init(order: Order): void {
    super.init(order);

    if (this.criteriaVariations.includes(eCriteriaVariation.ReusableParties)) {
      this.getReusableParties();
    }

    this.securedParty = order.parties?.find(party => Utilities.isSecuredParty(party)) || this.emptyEntityService.getEmptyParty(this.defaultType);
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return StepValidationState.ValidationSuccess;
  }

  protected override getParties(): Party[] {
    return this.order.parties!.filter(party => Utilities.isSecuredParty(party));
  }

  private getReusableParties() {
    this.reusablePartiesService.populateBaseLink([this.order.orderGroup!.corporationID]);
    var reusablePartyParams = new HttpParams().set('isVisible', true)
      .set('pageSize', 100)
      .append('PartyTypeIDs', 'BusinessSecuredParty')
      .append('PartyTypeIDs', 'IndividualSecuredParty');

    this.reusablePartiesService.getFirstPageSubscribable(reusablePartyParams).subscribe(parties => {
      this.reusableParties = parties;
    });
  }

  public override onSaving(): void {
    const securedParty = this.securedPartyForm.getParty();
    this.order.securedParty = securedParty;

    const nonSecuredParties = this.order.parties?.filter(party => party.partyTypeID !== ePartyType.businessSecuredParty && party.partyTypeID !== ePartyType.individualSecuredParty);
    this.order.parties = nonSecuredParties;
    this.order.parties?.push(securedParty);

    this.orderManager.updateOrder(this.order);
  }
}
